import { Constants } from "@ceeferenderer/fe-renderer-sdk/common/util";
import { FeExecutionTransformation } from "@ceeferenderer/fe-renderer-sdk";
import { envConfig } from "../config/envConfigs";
import { itgConfig } from "../config/itgConfig";

Constants.SELECTED = "data-selected";

export const itgExecution = new FeExecutionTransformation({
  ...itgConfig,
  ...envConfig.itgConfig,
});
